(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobi-dugar-delivery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dugar-delivery')){
  customElements.define('dugar-delivery',class extends HTMLElement{
    connectedCallback(){
      if(this.hasAttribute('data-delivery-custom')) return;
      const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const val=type=>Number(parts.find(p=>p.type===type).value);
      const today=Date.UTC(val('year'),val('month')-1,val('day'));
      const format=new Intl.DateTimeFormat('fr-FR',{timeZone:'UTC',day:'2-digit',month:'2-digit'});
      this.querySelector('[data-date-start]').textContent=format.format(new Date(today+5*86400000));
      this.querySelector('[data-date-end]').textContent=format.format(new Date(today+10*86400000));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobi-dugar-dimensions"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dugar-dimensions')){
  customElements.define('dugar-dimensions',class extends HTMLElement{
    connectedCallback(){
      this.values=JSON.parse(this.querySelector('script').textContent);
      this.section=this.closest('.shopify-section');
      this.update=()=>{const form=this.section.querySelector('form[id^="product-form-"]');const id=form?.elements.namedItem('id')?.value||this.dataset.initialVariant;const d=this.values[id];if(!d)return;this.querySelector('[data-dim-label]').textContent=d.label;for(const key of ['length','height','depth']){const element=this.querySelector('[data-dim="'+key+'"]');element.textContent=d[key]||'';element.closest('[data-dimension-item]').hidden=!d[key];}};
      this.onChange=()=>setTimeout(this.update,0);
      this.section.addEventListener('variant:change',this.onChange);
      this.section.addEventListener('change',this.onChange);
      this.update();
    }
    disconnectedCallback(){this.section?.removeEventListener('variant:change',this.onChange);this.section?.removeEventListener('change',this.onChange);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobi-halloween-pack-composition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobi-halloween-pack-composition')) {
    customElements.define('mobi-halloween-pack-composition', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.chairImages = JSON.parse(this.querySelector('[data-pack-chair-images]')?.textContent || '{}');
        this.enhanceChairChoices();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.enhanceChairChoices(), {once: true, signal: this.controller.signal});
        }
        document.addEventListener('variant:change', event => {
          if (event.target !== document.getElementById(this.getAttribute('form'))) return;
          const variant = event.detail.variant;
          if (!variant) return;
          const count = this.querySelector('[data-pack-chair-count]');
          if (count) count.textContent = String(variant.options[2]).trim().startsWith('6') ? '6' : '4';
          const chairImage = this.querySelector('[data-pack-chair-image] img');
          const chairSource = this.chairImages[variant.options[1]];
          if (chairImage && chairSource) {
            chairImage.removeAttribute('srcset');
            chairImage.src = chairSource;
          }
          const sofaImage = this.querySelector('[data-pack-sofa-image] img');
          const sofaSource = variant.featured_image?.src;
          if (sofaImage && sofaSource) {
            sofaImage.removeAttribute('srcset');
            sofaImage.src = sofaSource;
          }
        }, {signal: this.controller.signal});
      }
      enhanceChairChoices() {
        const formId = this.getAttribute('form');
        const picker = Array.from(document.querySelectorAll('variant-picker')).find(element => element.getAttribute('form') === formId);
        const inputs = picker?.querySelectorAll('input[type="radio"][name="option2"]');
        if (!inputs?.length) return;
        const fieldset = inputs[0].closest('fieldset');
        if (!fieldset || fieldset.classList.contains('hwpack-chair-choice')) return;
        const cards = Array.from(inputs).map(input => ({
          input,
          label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`),
          source: this.chairImages[input.value]
        }));
        if (cards.some(card => !card.label || !card.source)) return;
        const legend = fieldset.querySelector('legend');
        if (legend) {
          legend.textContent = this.dataset.chairHeading;
          legend.id = `${formId}-chair-heading`;
          fieldset.setAttribute('aria-labelledby', legend.id);
        }
        const help = document.createElement('p');
        help.id = `${formId}-chair-help`;
        help.className = 'hwpack-chair-choice__help';
        help.textContent = this.dataset.chairHelp;
        const info = fieldset.querySelector('.variant-picker__option-info');
        if (info) info.after(help);
        else fieldset.prepend(help);
        for (const {input, label, source} of cards) {
          const image = document.createElement('img');
          image.className = 'hwpack-chair-choice__image';
          image.src = source;
          image.alt = '';
          image.width = 320;
          image.height = 320;
          image.loading = 'lazy';
          image.decoding = 'async';
          const name = document.createElement('span');
          name.className = 'hwpack-chair-choice__name';
          name.textContent = input.value;
          const check = document.createElement('span');
          check.className = 'hwpack-chair-choice__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          label.replaceChildren(image, name, check);
          label.classList.add('hwpack-chair-choice__card');
          input.setAttribute('aria-describedby', help.id);
        }
        fieldset.classList.add('hwpack-chair-choice');
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobi-pc-config"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobi-pc-config')) {
    customElements.define('mobi-pc-config', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.quantity = 0;
        this.attempts = 0;
        this.busy = false;
        this.needsCartReview = false;
        this.completed = false;
        this.connect();
      }
      connect() {
        if (!this.isConnected || this.dataset.ready) return;
        const info = this.closest('.product-info');
        const form = document.getElementById(this.dataset.form);
        const picker = info && Array.from(info.querySelectorAll('variant-picker')).find(el => el.getAttribute('form') === this.dataset.form);
        const summary = info && Array.from(info.querySelectorAll('[data-pc-summary]')).find(el => el.dataset.pcSummary === this.dataset.form);
        if (!form || !picker || !summary || !picker.product || typeof picker.selectVariant !== 'function') {
          if (this.attempts++ < 100) this.timer = setTimeout(() => this.connect(), 100);
          return;
        }
        try { this.data = JSON.parse(this.querySelector('[data-pc-data]').textContent); } catch { return; }
        if (!Array.isArray(this.data.variants) || !this.data.variants.length) return;
        this.form = form;
        this.picker = picker;
        this.summary = summary;
        this.info = info;
        this.submitButton = summary.querySelector('[data-pc-submit]');
        this.errorElement = summary.querySelector('[data-pc-error]');
        this.cartLink = summary.querySelector('[data-pc-cart-link]');
        this.money = new Intl.NumberFormat(this.data.locale, {style: 'currency', currency: this.data.currency});
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const option = event.target.closest('[data-pc-option]');
          const quantity = event.target.closest('[data-pc-quantity]');
          if (option && this.contains(option) && !option.disabled && !this.busy) this.selectOption(Number(option.dataset.pcOption), option.dataset.pcValue);
          if (quantity && this.contains(quantity) && !quantity.disabled && !this.busy) {
            this.quantity = Number(quantity.dataset.pcQuantity);
            this.update();
          }
        }, {signal});
        form.addEventListener('variant:change', () => this.update(), {signal});
        form.addEventListener('change', () => queueMicrotask(() => this.update()), {signal});
        form.addEventListener('submit', event => this.submit(event), {capture: true, signal});
        window.addEventListener('pageshow', event => {
          if (event.persisted && this.completed) { this.completed = false; this.busy = false; this.update(); }
        }, {signal});
        this.quickAdds = Array.from(document.querySelectorAll('product-quick-add')).filter(el => el.getAttribute('form') === this.dataset.form).map(el => ({element: el, display: el.style.display}));
        this.quickAdds.forEach(item => {item.element.style.display = 'none';});
        info.classList.add('mpc-ready');
        this.dataset.ready = 'true';
        this.hidden = false;
        summary.hidden = false;
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.info?.classList.remove('mpc-ready');
        this.quickAdds?.forEach(item => {item.element.style.display = item.display;});
        if (this.summary) this.summary.hidden = true;
        delete this.dataset.ready;
      }
      currentVariant() {
        const id = this.form.elements.namedItem('id')?.value;
        return this.data.variants.find(variant => String(variant.id) === String(id));
      }
      candidate(index, value) {
        const current = this.currentVariant();
        if (!current) return null;
        const options = [...current.options];
        options[index] = value;
        return this.data.variants.find(variant => variant.options.every((option, i) => option === options[i]));
      }
      selectOption(index, value) {
        const next = this.candidate(index, value);
        if (!next || !next.available) return;
        this.picker.selectVariant(next.id);
        this.update();
      }
      format(cents) { return this.money.format(cents / 100); }
      update() {
        if (!this.data || !this.form) return;
        const variant = this.currentVariant();
        const chevet = this.data.chevet;
        const labels = this.data.labels;
        this.querySelectorAll('[data-pc-option]').forEach(button => {
          const index = Number(button.dataset.pcOption);
          const candidate = this.candidate(index, button.dataset.pcValue);
          button.setAttribute('aria-pressed', String(Boolean(variant && variant.options[index] === button.dataset.pcValue)));
          button.disabled = this.busy || !candidate || !candidate.available;
          const price = button.querySelector('[data-pc-version-price], [data-pc-mattress-price]');
          if (price) price.textContent = candidate ? this.format(candidate.price) : labels.unavailable;
        });
        this.querySelectorAll('[data-pc-quantity]').forEach(button => {
          const quantity = Number(button.dataset.pcQuantity);
          button.setAttribute('aria-pressed', String(quantity === this.quantity));
          button.disabled = this.busy || (quantity > 0 && (!this.validId(chevet.id) || !chevet.available));
        });
        this.querySelector('[data-pc-explanation]').textContent = variant?.options[this.data.environmentIndex] === 'Prime' ? labels.primeExplanation : labels.classicExplanation;
        const mattressLabel = variant && Number.isInteger(this.data.mattressIndex) ? ` · ${variant.options[this.data.mattressIndex]}` : '';
        this.summary.querySelector('[data-pc-bed-label]').textContent = variant ? `${this.data.title} · ${variant.options[this.data.environmentIndex]} · ${variant.options[this.data.sizeIndex].replace(' x ', ' × ')} cm${mattressLabel}` : labels.unavailable;
        this.summary.querySelector('[data-pc-bed-price]').textContent = variant ? this.format(variant.price) : '—';
        this.summary.querySelector('[data-pc-chevet-label]').textContent = this.quantity ? `${this.quantity} × ${chevet.title} · ${this.format(chevet.price)} ${labels.each}` : labels.noChevet;
        this.summary.querySelector('[data-pc-chevet-price]').textContent = this.format(this.quantity * chevet.price);
        this.summary.querySelector('[data-pc-total]').textContent = variant ? this.format(variant.price + this.quantity * chevet.price) : '—';
        this.submitButton.disabled = this.busy || this.needsCartReview || this.completed || !variant || !variant.available || !this.validId(variant.id) || (this.quantity > 0 && (!this.validId(chevet.id) || !chevet.available));
        this.submitButton.textContent = this.busy ? labels.adding : variant?.available ? labels.add : labels.unavailable;
        this.submitButton.setAttribute('aria-busy', String(this.busy));
      }
      validId(id) { return /^\d+$/.test(String(id)) && Number(id) > 0 && Number.isSafeInteger(Number(id)); }
      async submit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || this.needsCartReview || this.completed) return;
        if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
        const variant = this.currentVariant();
        const chevet = this.data.chevet;
        if (!variant?.available || !this.validId(variant.id) || ![0, 1, 2].includes(this.quantity) || (this.quantity > 0 && (!chevet.available || !this.validId(chevet.id)))) return;
        const bed = {id: variant.id, quantity: 1};
        const properties = {};
        for (const [name, value] of new FormData(this.form)) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) bed.properties = properties;
        const items = [bed];
        if (this.quantity) items.push({id: chevet.id, quantity: this.quantity});
        this.busy = true;
        this.errorElement.hidden = true;
        this.cartLink.hidden = true;
        this.update();
        try {
          const response = await fetch(this.data.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items})
          });
          if (!response.ok) throw new Error('cart');
          this.completed = true;
          window.location.assign(this.data.cartUrl);
        } catch {
          this.needsCartReview = true;
          this.errorElement.textContent = this.data.labels.error;
          this.errorElement.hidden = false;
          this.cartLink.hidden = false;
        } finally {
          this.busy = false;
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
